import { FC, memo } from "react"
import { useMediaQuery } from "../../hooks"

const SELL_BITCOIN = `How to\nSell Coins?`
const BUY_BITCOIN = "How to\nBuy Coins?"

type Props = {
  //
}

const HowToBlockComponent: FC<Props> = () => {
  const isMobile = useMediaQuery("(max-width: 768px)")

  return (
    <div style={{ background: "url(/img/icons_new/how_to_bg.png) #0021A0 bottom" }}>
      <div
        className="container"
        style={{
          padding: `90px ${isMobile ? "15px" : "0"} 95px`,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "20px",
          color: "#ffffff",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "46px", flex: 1 }}>
          <div style={{ position: "relative" }}>
            <div
              style={{ width: "117px", height: "20px", backgroundColor: "#E41E1F", position: "absolute", left: "-5px", bottom: "7px" }}
            />
            <h2
              className="how__title title"
              style={{ marginBottom: 0, textAlign: isMobile ? "center" : undefined, whiteSpace: "pre", position: "relative" }}
            >
              {BUY_BITCOIN}
            </h2>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>01</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Sign Up</span>
              <span>Provide a valid e-mail, protect it with a strong password, set up your wallet and you're good to go!</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>02</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Verify</span>
              <span>
                Purchasing cryptocurrency without KYC (Know Your Customer) is impossible today. With us it's simple. Be ready to provide us
                with your ID & personal information.
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>03</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Buy Crypto</span>
              <span>Buy coins with Credit Card, Debit Card, Wire Transfer.</span>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "46px", flex: 1 }}>
          <div style={{ position: "relative" }}>
            <div
              style={{ width: "117px", height: "20px", backgroundColor: "#E41E1F", position: "absolute", left: "-5px", bottom: "7px" }}
            />
            <h2
              className="how__title title"
              style={{ marginBottom: 0, textAlign: isMobile ? "center" : undefined, whiteSpace: "pre", position: "relative" }}
            >
              {SELL_BITCOIN}
            </h2>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>01</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Start a Transaction</span>
              <span>
                Create a 7gates.exchange account, choose "You spend" (coin) and "You receive" (Credit Card), enter the amount, and click
                "Sell" to proceed.
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>02</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Enter Credit Card Information</span>
              <span>
                Enter your 16 or 18-digit card number to receive your funds. 7gates.exchange is PCI DSS certified, ensuring your data is
                secure.
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>03</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Send Your Coins</span>
              <span>Send coins to the provided address and cover any sending fees.</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(255, 255, 255, 0.4)",
                padding: "20px 30px",
                gap: "12px",
                borderRadius: "20px",
                backdropFilter: "blur(34px)",
              }}
            >
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>04</span>
              <span style={{ fontSize: "32px", lineHeight: "115%", fontWeight: 900 }}>Receive Your Payout</span>
              <span>
                Once the coin transfer is confirmed, your fiat will be sent to your credit card. Most payouts are instant, while some may
                take up to 1 business day.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const HowToBlock = memo(HowToBlockComponent)
